// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const ReviewsInvitationService = {
    CreateReviewInvitation(fn, _req) {
        return fn(`/reviews/invitation/v1`, { method: "POST" });
    },
    GetReviewInvitation(fn, req) {
        try {
            fm.validateUrlParam(req["invitationId"], "invitationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/reviews/invitation/v1/${req["invitationId"]}?${fm.renderURLSearchParams(req, ["invitationId"])}`, { method: "GET" });
    },
};
